(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3849],{

/***/ 49563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ BackgroundImage; }
/* harmony export */ });
/* unused harmony export _BackgroundImage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64761);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97818);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48427);
/* harmony import */ var _Box_Box_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64523);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  radius: 0
};
const _BackgroundImage = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .useComponentDefaultProps */ .N4)("BackgroundImage", defaultProps, props), { src, radius, sx } = _a, others = __objRest(_a, ["src", "radius", "sx"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Box_Box_js__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, __spreadProps(__spreadValues({}, others), {
    ref,
    sx: [
      (theme) => __spreadProps(__spreadValues({}, theme.fn.focusStyles()), {
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "block",
        width: "100%",
        border: 0,
        textDecoration: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        backgroundImage: `url(${src})`,
        borderRadius: theme.fn.radius(radius)
      }),
      ...(0,_mantine_utils__WEBPACK_IMPORTED_MODULE_3__/* .packSx */ .R)(sx)
    ]
  }));
});
_BackgroundImage.displayName = "@mantine/core/BackgroundImage";
const BackgroundImage = (0,_mantine_utils__WEBPACK_IMPORTED_MODULE_4__/* .createPolymorphicComponent */ .F)(_BackgroundImage);


//# sourceMappingURL=BackgroundImage.js.map


/***/ }),

/***/ 21017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// UNUSED EXPORTS: _Card

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.context.js


const CardContext = (0,react.createContext)({ padding: 0 });
const CardProvider = CardContext.Provider;
const useCardPadding = () => (0,react.useContext)(CardContext).padding;


//# sourceMappingURL=Card.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/CardSection/CardSection.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { padding, withBorder, inheritPadding }) => {
  const spacing = theme.fn.size({ size: padding, sizes: theme.spacing });
  const offset = -1 * spacing;
  const borderColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
  return {
    cardSection: {
      display: "block",
      marginLeft: offset,
      marginRight: offset,
      paddingLeft: inheritPadding ? spacing : void 0,
      paddingRight: inheritPadding ? spacing : void 0,
      borderTop: withBorder && `1px solid ${borderColor}`,
      borderBottom: withBorder && `1px solid ${borderColor}`,
      "& + &": {
        borderTop: 0
      },
      "&[data-first]": {
        marginTop: offset,
        borderTop: 0,
        borderBottom: withBorder && `1px solid ${borderColor}`
      },
      "&[data-last]": {
        marginBottom: offset,
        borderBottom: 0
      }
    }
  };
});

/* harmony default export */ var CardSection_styles = (useStyles);
//# sourceMappingURL=CardSection.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/CardSection/CardSection.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  withBorder: false,
  inheritPadding: false
};
const _CardSection = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("CardSection", defaultProps, props), { className, withBorder, inheritPadding, unstyled } = _a, others = __objRest(_a, ["className", "withBorder", "inheritPadding", "unstyled"]);
  const { classes, cx } = CardSection_styles({ padding: useCardPadding(), withBorder, inheritPadding }, { name: "Card", unstyled });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.cardSection, className),
    ref
  }, others));
});
_CardSection.displayName = "@mantine/core/CardSection";
const CardSection = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_CardSection);


//# sourceMappingURL=CardSection.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.styles.js


var Card_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
  }
}));

/* harmony default export */ var Card_styles = (Card_styles_useStyles);
//# sourceMappingURL=Card.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Card/Card.js








var Card_defProp = Object.defineProperty;
var Card_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Card_hasOwnProp = Object.prototype.hasOwnProperty;
var Card_propIsEnum = Object.prototype.propertyIsEnumerable;
var Card_defNormalProp = (obj, key, value) => key in obj ? Card_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Card_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Card_hasOwnProp.call(b, prop))
      Card_defNormalProp(a, prop, b[prop]);
  if (Card_getOwnPropSymbols)
    for (var prop of Card_getOwnPropSymbols(b)) {
      if (Card_propIsEnum.call(b, prop))
        Card_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Card_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Card_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Card_getOwnPropSymbols)
    for (var prop of Card_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Card_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Card_defaultProps = {
  p: "md"
};
const _Card = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Card", Card_defaultProps, props), { className, p, radius, children, unstyled } = _a, others = Card_objRest(_a, ["className", "p", "radius", "children", "unstyled"]);
  const { classes, cx } = Card_styles(null, { name: "Card", unstyled });
  const _children = react.Children.toArray(children);
  const content = _children.map((child, index) => {
    if (typeof child === "object" && child && "type" in child && child.type === CardSection) {
      return (0,react.cloneElement)(child, {
        padding: p,
        "data-first": index === 0 || void 0,
        "data-last": index === _children.length - 1 || void 0
      });
    }
    return child;
  });
  return /* @__PURE__ */ react.createElement(CardProvider, {
    value: { padding: p }
  }, /* @__PURE__ */ react.createElement(Paper/* Paper */.X, Card_spreadValues({
    className: cx(classes.root, className),
    radius,
    p,
    ref
  }, others), content));
});
_Card.Section = CardSection;
_Card.displayName = "@mantine/core/Card";
const Card = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_Card);


//# sourceMappingURL=Card.js.map


/***/ }),

/***/ 9094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ Center; }
/* harmony export */ });
/* unused harmony export _Center */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64761);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97818);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48427);
/* harmony import */ var _Box_Box_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64523);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const _Center = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .useComponentDefaultProps */ .N4)("Center", {}, props), { inline, sx } = _a, others = __objRest(_a, ["inline", "sx"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Box_Box_js__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, __spreadValues({
    ref,
    sx: [
      {
        display: inline ? "inline-flex" : "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      ...(0,_mantine_utils__WEBPACK_IMPORTED_MODULE_3__/* .packSx */ .R)(sx)
    ]
  }, others));
});
_Center.displayName = "@mantine/core/Center";
const Center = (0,_mantine_utils__WEBPACK_IMPORTED_MODULE_4__/* .createPolymorphicComponent */ .F)(_Center);


//# sourceMappingURL=Center.js.map


/***/ }),

/***/ 18540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ MediaQuery; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/MediaQuery/MediaQuery.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { smallerThan, largerThan, query, styles }) => {
  const media = {};
  const minWidth = theme.fn.size({ size: largerThan, sizes: theme.breakpoints });
  const maxWidth = theme.fn.size({ size: smallerThan, sizes: theme.breakpoints });
  const _styles = typeof styles === "function" ? styles(theme) : styles;
  if (largerThan !== void 0 && smallerThan !== void 0) {
    media[`@media (min-width: ${minWidth}px) and (max-width: ${maxWidth - 1}px)`] = _styles;
  } else {
    if (largerThan !== void 0) {
      media[`@media (min-width: ${theme.fn.size({ size: largerThan, sizes: theme.breakpoints })}px)`] = _styles;
    }
    if (smallerThan !== void 0) {
      media[`@media (max-width: ${theme.fn.size({ size: smallerThan, sizes: theme.breakpoints }) - 1}px)`] = _styles;
    }
  }
  if (query) {
    media[`@media ${query}`] = _styles;
  }
  return { media };
});

/* harmony default export */ var MediaQuery_styles = (useStyles);
//# sourceMappingURL=MediaQuery.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js




function MediaQuery(props) {
  var _a;
  const { children, smallerThan, largerThan, query, styles, className } = (0,MantineProvider/* useComponentDefaultProps */.N4)("MediaQuery", {}, props);
  const { classes, cx } = MediaQuery_styles({ smallerThan, largerThan, query, styles }, { name: "MediaQuery" });
  const child = react.Children.only(children);
  if (typeof child === "object" && child !== null && "props" in child) {
    return react.cloneElement(child, {
      className: cx(classes.media, (_a = child.props) == null ? void 0 : _a.className, className)
    });
  }
  return child;
}
MediaQuery.displayName = "@mantine/core/MediaQuery";


//# sourceMappingURL=MediaQuery.js.map


/***/ }),

/***/ 38623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.styles.js


const fade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  "from, to": { opacity: 0.4 },
  "50%": { opacity: 1 }
});
var useStyles = (0,create_styles/* createStyles */.k)((theme, { height, width, radius, circle, animate }) => ({
  root: {
    height,
    width: circle ? height : width,
    borderRadius: circle ? height : theme.fn.radius(radius),
    position: "relative",
    WebkitTransform: "translateZ(0)"
  },
  visible: {
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      background: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10
    },
    "&::after": {
      content: '""',
      position: "absolute",
      background: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      animation: animate ? `${fade} 1500ms linear infinite` : "none",
      zIndex: 11
    }
  }
}));

/* harmony default export */ var Skeleton_styles = (useStyles);

//# sourceMappingURL=Skeleton.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  height: "auto",
  width: "100%",
  visible: true,
  animate: true
};
const Skeleton = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Skeleton", defaultProps, props), { height, width, visible, animate, className, circle, radius, unstyled } = _a, others = __objRest(_a, ["height", "width", "visible", "animate", "className", "circle", "radius", "unstyled"]);
  const { classes, cx } = Skeleton_styles({ height, width, circle, radius, animate }, { unstyled, name: "Skeleton" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, { [classes.visible]: visible }, className),
    ref
  }, others));
});
Skeleton.displayName = "@mantine/core/Skeleton";


//# sourceMappingURL=Skeleton.js.map


/***/ }),

/***/ 19236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function getFontSize(size, element, theme) {
  if (typeof size !== "undefined") {
    return size in theme.headings.sizes ? theme.headings.sizes[size].fontSize : size;
  }
  return theme.headings.sizes[element].fontSize;
}
function getLineHeight(size, element, theme) {
  if (typeof size !== "undefined" && size in theme.headings.sizes) {
    return theme.headings.sizes[size].lineHeight;
  }
  return theme.headings.sizes[element].lineHeight;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { element, weight, size, inline }) => ({
  root: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
    fontFamily: theme.headings.fontFamily,
    fontWeight: weight || theme.headings.sizes[element].fontWeight || theme.headings.fontWeight,
    fontSize: getFontSize(size, element, theme),
    lineHeight: inline ? 1 : getLineHeight(size, element, theme),
    margin: 0
  })
}));

/* harmony default export */ var Title_styles = (useStyles);
//# sourceMappingURL=Title.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.js





var Title_defProp = Object.defineProperty;
var Title_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Title_hasOwnProp = Object.prototype.hasOwnProperty;
var Title_propIsEnum = Object.prototype.propertyIsEnumerable;
var Title_defNormalProp = (obj, key, value) => key in obj ? Title_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Title_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Title_hasOwnProp.call(b, prop))
      Title_defNormalProp(a, prop, b[prop]);
  if (Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(b)) {
      if (Title_propIsEnum.call(b, prop))
        Title_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Title_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Title_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  order: 1
};
const Title = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Title", defaultProps, props), { className, order, children, unstyled, size, weight, inline } = _a, others = __objRest(_a, ["className", "order", "children", "unstyled", "size", "weight", "inline"]);
  const { classes, cx } = Title_styles({ element: `h${order}`, weight, size, inline }, { name: "Title", unstyled });
  if (![1, 2, 3, 4, 5, 6].includes(order)) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, Title_spreadValues({
    component: `h${order}`,
    ref,
    className: cx(classes.root, className)
  }, others), children);
});
Title.displayName = "@mantine/core/Title";


//# sourceMappingURL=Title.js.map


/***/ }),

/***/ 49508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lien-he",
      function () {
        return __webpack_require__(43715);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59926);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);







function DefaultSEO(param) {
    var seo = param.seo;
    // console.log(445555, seo)
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    if (!seo || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(seo)) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture1,
                size: "xl"
            }),
            width: 1200,
            height: 630,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    } else if (seo.picture2) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture2,
                size: "xl"
            }),
            width: 1200,
            height: 1200,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
        title: seo === null || seo === void 0 ? void 0 : seo.title,
        description: seo === null || seo === void 0 ? void 0 : seo.description,
        openGraph: {
            url: "https://vietthien.com",
            title: seo.title,
            description: seo.description,
            images: images,
            locale: locale,
            type: seo.type || "website",
            siteName: "Việt Thi\xean",
            article: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (seo === null || seo === void 0 ? void 0 : seo.article) || {})
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 43715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ LienHe; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _apis_queryFunctions_appInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78055);
/* harmony import */ var _apis_queryFunctions_contact__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31670);
/* harmony import */ var _apis_queryFunctions_ecompagesFunctions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4088);
/* harmony import */ var _common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6559);
/* harmony import */ var _common_components_DefaultSEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51623);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26679);
/* harmony import */ var _setup_locale_provider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59963);
/* harmony import */ var _setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97744);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22312);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64523);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(62679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(49563);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9094);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(21017);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(18540);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(19236);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(80061);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(52615);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(67841);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(73723);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(92470);
/* harmony import */ var _mantine_form__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98903);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48228);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* eslint-disable react/no-array-index-key */ /* eslint-disable react/jsx-props-no-spreading */ 


















var __N_SSG = true;
function LienHe(param) {
    var dataSEO = param.dataSEO;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var getLabel = (0,_setup_locale_provider__WEBPACK_IMPORTED_MODULE_7__/* .useLocalContext */ .u)().getLabel;
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)().locale;
    var ref8 = (0,_apis_queryFunctions_ecompagesFunctions__WEBPACK_IMPORTED_MODULE_3__/* .useFetchEcompage */ .VM)("trang-lien-he-viet-thien", locale), detail = ref8.data;
    var ref9 = (0,_apis_queryFunctions_appInfo__WEBPACK_IMPORTED_MODULE_1__/* .useFetchAppInfo */ .k0)({}), appInfo = ref9.data;
    /* const { data } = useFetchEcompage("trang-lien-he", locale);
  const pictureVT = data?.add_on_data_3[0]||{}; */ // console.log("detail", detail);
    console.log("update_88");
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_11__.useState(0), 2), value = ref10[0], setValue = ref10[1];
    var form = (0,_mantine_form__WEBPACK_IMPORTED_MODULE_13__/* .useForm */ .c)({
        initialValues: {
            ho_ten: "",
            dien_thoai: "",
            email: "",
            dia_chi: "",
            noi_dung: ""
        },
        validate: {
            ho_ten: function(value) {
                return value.length > 0 ? null : "Vui l\xf2ng nhập họ t\xean của qu\xfd kh\xe1ch";
            },
            email: function(value) {
                return value.length > 0 ? /^\S+@\S+$/.test(value) ? null : "Email kh\xf4ng hợp lệ" : "Vui l\xf2ng nhập email để cửa h\xe0ng li\xean hệ với qu\xfd kh\xe1ch";
            },
            // dien_thoai: (value) =>
            //   value.length > 0
            //     ? /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/.test(
            //         value
            //       )
            //       ? null
            //       : "Số điện thoại không hợp lệ"
            //     : "Vui lòng nhập số điện thoại của quý khách",
            noi_dung: function(value) {
                return value.length > 0 ? null : "Vui l\xf2ng nhập nội dung";
            }
        }
    });
    var contactMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_14__/* .useMutation */ .D)(_apis_queryFunctions_contact__WEBPACK_IMPORTED_MODULE_2__/* .postContact */ .D, {
        onSuccess: function(rs) {
            if (rs._id) {
                (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_8__/* .appAlert */ .t)({
                    type: "success",
                    message: "Gửi th\xf4ng tin th\xe0nh c\xf4ng"
                });
            } else {
                (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_8__/* .appAlert */ .t)({
                    message: "Gửi th\xf4ng tin kh\xf4ng th\xe0nh c\xf4ng"
                });
            }
            form.reset();
        }
    });
    var handleSubmit = function() {
        contactMutation.mutate((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, form.values));
    };
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_components_DefaultSEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                seo: dataSEO
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: "xl" /* sx={{background:"pink"}} */ ,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                            py: 20,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Grid */ .r, {
                                grow: true,
                                gutter: 70,
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Grid.Col */ .r.Col, {
                                        xs: 12,
                                        sm: 5,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_18__/* .BackgroundImage */ .X, {
                                            src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                                src: detail === null || detail === void 0 ? void 0 : (ref = detail.add_on_data_3) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.picture
                                            }),
                                            style: {
                                                backgroundSize: "cover",
                                                height: "610px",
                                                borderRadius: "20px"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                style: {
                                                    background: "linear-gradient(360deg, rgba(18, 133, 79, 0.80) 30%, rgba(18, 133, 79, 0.00) 50%)",
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: "20px"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Center */ .M, {
                                                    p: "lg",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                                                            pt: 450,
                                                            children: [
                                                                Boolean(detail) && ((ref3 = detail === null || detail === void 0 ? void 0 : (ref2 = detail.add_on_data_2) === null || ref2 === void 0 ? void 0 : ref2.filter(function(el) {
                                                                    return el.shared;
                                                                })) === null || ref3 === void 0 ? void 0 : ref3.map(function(item, index) {
                                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Text */ .x, {
                                                                        mb: 8,
                                                                        color: "#FFF",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                                                children: [
                                                                                    item === null || item === void 0 ? void 0 : item.title,
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            item === null || item === void 0 ? void 0 : item.summary
                                                                        ]
                                                                    }, index);
                                                                })),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Text */ .x, {
                                                                    mb: 8,
                                                                    color: "#FFF",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                                            children: [
                                                                                trans === null || trans === void 0 ? void 0 : trans.contact.email,
                                                                                ": "
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        appInfo === null || appInfo === void 0 ? void 0 : appInfo.email
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Text */ .x, {
                                                                    mb: 8,
                                                                    color: "#FFF",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                                            children: [
                                                                                trans === null || trans === void 0 ? void 0 : trans.contact.address,
                                                                                ": "
                                                                            ]
                                                                        }),
                                                                        locale === "vi" ? appInfo === null || appInfo === void 0 ? void 0 : appInfo.address : appInfo === null || appInfo === void 0 ? void 0 : appInfo.address_en
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Grid.Col */ .r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_21__/* .Card */ .Z, {
                                            shadow: "sm",
                                            p: "lg",
                                            radius: "md",
                                            withBorder: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_22__/* .MediaQuery */ .z, {
                                                    smallerThan: "md",
                                                    order: 4,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_23__/* .Title */ .D, (_obj = {
                                                        className: "webview",
                                                        order: 1,
                                                        size: "h4",
                                                        align: "justify",
                                                        color: "#12854F",
                                                        weight: 950
                                                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, "size", 36), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, "children", trans === null || trans === void 0 ? void 0 : trans.contact.form.title), _obj))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Text */ .x, {
                                                    mb: 10,
                                                    children: trans === null || trans === void 0 ? void 0 : trans.contact.content
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                                    onSubmit: form.onSubmit(handleSubmit),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_25__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                            label: trans === null || trans === void 0 ? void 0 : trans.contact.form.fullName,
                                                            withAsterisk: true,
                                                            size: "sm",
                                                            placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder.fullName
                                                        }, form.getInputProps("ho_ten")), {
                                                            mb: 12
                                                        })),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_25__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                            label: trans === null || trans === void 0 ? void 0 : trans.contact.form.phone,
                                                            size: "sm",
                                                            placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder.phone
                                                        }, form.getInputProps("dien_thoai")), {
                                                            mb: 12
                                                        })),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_25__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                            label: trans === null || trans === void 0 ? void 0 : trans.contact.form.email,
                                                            withAsterisk: true,
                                                            size: "sm",
                                                            placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder.email
                                                        }, form.getInputProps("email")), {
                                                            mb: 12
                                                        })),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_25__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                            label: trans === null || trans === void 0 ? void 0 : trans.contact.form.address,
                                                            size: "sm",
                                                            placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder.address
                                                        }, form.getInputProps("dia_chi")), {
                                                            mb: 12
                                                        })),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_27__/* .Textarea */ .g, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                            placeholder: trans === null || trans === void 0 ? void 0 : trans.contact.placeholder.content,
                                                            withAsterisk: true,
                                                            label: trans === null || trans === void 0 ? void 0 : trans.contact.form.content,
                                                            size: "sm",
                                                            autosize: true,
                                                            minRows: 2,
                                                            maxRows: 2
                                                        }, form.getInputProps("noi_dung"))),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_28__/* .Group */ .Z, {
                                                            position: "center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_29__/* .Button */ .z, {
                                                                type: "submit",
                                                                h: 40,
                                                                fullWidth: true,
                                                                variant: "filled",
                                                                bg: "12854F",
                                                                radius: "xl",
                                                                style: {
                                                                    margin: "25px 0 10px 0"
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Text */ .x, {
                                                                    weight: "500",
                                                                    transform: "uppercase",
                                                                    children: trans === null || trans === void 0 ? void 0 : trans.contact.form.button
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                            py: 20,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Center */ .M, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_22__/* .MediaQuery */ .z, {
                                        smallerThan: "md",
                                        order: 4,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_23__/* .Title */ .D, {
                                            order: 1,
                                            size: "h4",
                                            children: trans === null || trans === void 0 ? void 0 : trans.contact.map.title.toUpperCase()
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_30__/* .Skeleton */ .O, {
                                    visible: !detail,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                                        pt: 20,
                                        sx: {
                                            minHeight: 470
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Grid */ .r, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Grid.Col */ .r.Col, {
                                                    xs: 12,
                                                    md: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_22__/* .MediaQuery */ .z, {
                                                        smallerThan: "md",
                                                        styles: {
                                                            height: 250
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_31__/* .ScrollArea */ .x, {
                                                            children: Boolean(detail) && (detail === null || detail === void 0 ? void 0 : detail.add_on_data) && ((ref5 = detail === null || detail === void 0 ? void 0 : (ref4 = detail.add_on_data) === null || ref4 === void 0 ? void 0 : ref4.filter(function(el) {
                                                                return el.shared;
                                                            })) === null || ref5 === void 0 ? void 0 : ref5.map(function(item, i) {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_32__/* .NavLink */ .O, {
                                                                    label: getLabel(item.title),
                                                                    description: getLabel(item.summary),
                                                                    onClick: function() {
                                                                        return setValue(i);
                                                                    },
                                                                    active: i === value,
                                                                    styles: {
                                                                        label: {
                                                                            fontSize: 16,
                                                                            fontWeight: 700
                                                                        }
                                                                    }
                                                                }, i);
                                                            }))
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Grid.Col */ .r.Col, {
                                                    sx: {
                                                        padding: 0,
                                                        paddingTop: 8
                                                    },
                                                    xs: 12,
                                                    md: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: detail === null || detail === void 0 ? void 0 : (ref6 = detail.add_on_data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[value]) === null || ref7 === void 0 ? void 0 : ref7.content
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49508); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);